/******************************************************************************
 *
 * PageHeader
 *
 * Standard Header for all WMS pages.
 *
 * Usage
 *
 * <PageHeader
 *      title="Work Management"
 *      subtitle="Manage template and adhoc works"
 *      actions={<></>}
 * />
 *
 ******************************************************************************/

import React from "react";

export default function PageHeader({

    title,

    subtitle,

    actions

}) {

    return (

        <div
            className="rounded-3 shadow-sm mb-4"
            style={{
                background: "linear-gradient(90deg,#2563eb,#4f86f7)",
                color: "#fff"
            }}
        >

            <div className="p-3 p-md-4">

                <div className="d-flex justify-content-between align-items-center flex-wrap gap-3">

                    {/* Left */}

                    <div>

                        <h2
                            className="fw-bold mb-1"
                            style={{ color: "#fff" }}
                        >
                            {title}
                        </h2>

                        <div
                            style={{
                                color: "rgba(255,255,255,.85)",
                                fontSize: ".92rem"
                            }}
                        >
                            {subtitle}
                        </div>

                    </div>

                    {/* Right */}

                    <div
                        className="d-flex flex-wrap gap-2"
                    >
                        {actions}
                    </div>

                </div>

            </div>

        </div>

    );

}